<div class="error-container">
  <div class="failed"></div>
  @if (!isProductsScreen) {
    <div class="error-text">We couldn’t verify your {{errorField}}. Please update it above {{errorText}} </div>
  }
  @if (isProductsScreen) {
    <div class="error-text">{{errorText}}</div>
  }
</div>
